module.exports = __webpack_public_path__ + "static/media/watermelon-salad.88ba3450.png";